import { useInfiniteQuery } from '@tanstack/react-query';

import { notificationService } from '@/services/rest';
import { notificationKey } from './queryKeys';

const PAGE_SIZE = 20;

export const useInfiniteNotifications = (userId?: string) =>
    useInfiniteQuery({
        queryKey: userId
            ? notificationKey.infinite(userId, PAGE_SIZE)
            : ['__disabled__'],
        enabled: Boolean(userId),
        initialPageParam: 0,
        queryFn: ({ pageParam }) =>
            notificationService().index({
                userId: userId!,
                takeCount: PAGE_SIZE,
                skipCount: pageParam,
            }),
        getNextPageParam: (last, all) => {
            const loaded = all.reduce(
                (s, p) => s + (p?.result?.items?.length ?? 0),
                0
            );

            const total = last?.result?.totalCount ?? 0;

            return loaded < total ? loaded : undefined;
        },
        staleTime: 0,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });
